import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { BriefcaseIcon, HeartIcon, GraduationCapIcon, UsersIcon, CheckIcon } from 'lucide-react';
export function Careers() {
  const openPositions = [{
    id: 1,
    title: 'Administrative Assistant to the Director',
    department: 'Operations',
    location: 'Pattaya, Thailand',
    type: 'Full-Time | On-Site',
    description: 'Support the Chief R&D Officer in managing a fast-growing, multi-venture international ecosystem spanning hospitality, wellness, real estate, logistics, and digital media.',
    link: '/careers/administrative-assistant'
  }, {
    id: 2,
    title: 'Senior Microbiome Research Scientist',
    department: 'Research',
    location: 'San Francisco, CA',
    type: 'Full-Time',
    description: 'Lead research projects investigating the gut-brain axis and develop novel microbiome-based therapeutic interventions.',
    link: '/careers/senior-research-scientist'
  }, {
    id: 3,
    title: 'Clinical Research Coordinator',
    department: 'Research',
    location: 'San Francisco, CA',
    type: 'Full-Time',
    description: 'Coordinate clinical trials, manage participant recruitment, and ensure compliance with research protocols and regulatory requirements.',
    link: '/careers/clinical-research-coordinator'
  }, {
    id: 4,
    title: 'Bioinformatics Analyst',
    department: 'Research',
    location: 'San Francisco, CA / Remote',
    type: 'Full-Time',
    description: 'Analyze complex microbiome sequencing data, develop computational pipelines, and contribute to research publications.',
    link: '/careers/bioinformatics-analyst'
  }, {
    id: 5,
    title: 'Laboratory Technician',
    department: 'Research',
    location: 'San Francisco, CA',
    type: 'Full-Time',
    description: 'Perform laboratory procedures for microbiome analysis, maintain equipment, and support research scientists.',
    link: '/careers/laboratory-technician'
  }, {
    id: 6,
    title: 'Certification Program Manager',
    department: 'Ukweli Institute',
    location: 'San Francisco, CA',
    type: 'Full-Time',
    description: 'Manage the Ukweli Certified™ program, coordinate product testing, and develop certification standards.',
    link: '/careers/certification-program-manager'
  }, {
    id: 7,
    title: 'Global Health Program Coordinator',
    department: 'Afya Program',
    location: 'East Africa / Remote',
    type: 'Full-Time',
    description: 'Coordinate implementation of microbiome health interventions in underserved communities and build local partnerships.',
    link: '/careers/global-health-coordinator'
  }, {
    id: 8,
    title: 'Science Communications Specialist',
    department: 'Communications',
    location: 'San Francisco, CA / Remote',
    type: 'Full-Time',
    description: 'Translate complex research findings into accessible content for diverse audiences through articles, social media, and educational materials.',
    link: '/careers/science-communications-specialist'
  }];
  const benefits = [{
    title: 'Comprehensive Health Coverage',
    description: 'Full medical, dental, and vision insurance for employees and dependents',
    icon: <HeartIcon size={20} className="text-teal-600" data-id="element-1266" data-mp="29w1n6ttmae2j" />
  }, {
    title: 'Professional Development',
    description: 'Annual stipend for conferences, courses, and continuing education',
    icon: <GraduationCapIcon size={20} className="text-teal-600" data-id="element-1267" data-mp="2iwzlcvhdjrd7" />
  }, {
    title: 'Collaborative Environment',
    description: 'Work alongside world-class scientists and contribute to groundbreaking research',
    icon: <UsersIcon size={20} className="text-teal-600" data-id="element-1268" data-mp="ok07b6sn7581" />
  }, {
    title: 'Work-Life Balance',
    description: 'Flexible scheduling, remote work options, and generous paid time off',
    icon: <BriefcaseIcon size={20} className="text-teal-600" data-id="element-1269" data-mp="uxduvgc39wow" />
  }];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1270" data-mp="zz3azae650ju">
      <Header data-id="element-1271" data-mp="14x4q5k8h4fq1" />
      <main className="flex-grow" data-id="element-1272" data-mp="14xoaf7lljg78">
        {/* Hero Section */}
        <section className="bg-navy-800 text-white py-16" data-id="element-1273" data-mp="14v21b3j24smw">
          <div className="container mx-auto px-4" data-id="element-1274" data-mp="7aflt3qatr10">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1275" data-mp="c8h0lcgoz46o">
              <h1 className="text-4xl font-bold mb-4" data-id="element-1276" data-mp="c90iwua97ul8">Join Our Mission</h1>
              <p className="text-xl mb-8" data-id="element-1277" data-mp="h7airi6xbjd6">
                Help us advance microbiome science and transform human health
              </p>
              <div className="w-20 h-1 bg-teal-400 mx-auto" data-id="element-1278" data-mp="lzlj2m5kt769"></div>
            </div>
          </div>
        </section>
        {/* Our Culture Section */}
        <section className="py-16" data-id="element-1279" data-mp="3pmls45d20w7j">
          <div className="container mx-auto px-4" data-id="element-1280" data-mp="3plsq1hp1iuvq">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1281" data-mp="3i4e71iakrgi5">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1282" data-mp="3i1i7xqmzqls4">
                Our Culture
              </h2>
              <p className="text-gray-600" data-id="element-1283" data-mp="385ol9efk5bwm">
                At CalMiR, we're committed to fostering an environment of
                scientific excellence, collaboration, and innovation. We value
                diversity of thought and background, believing that the most
                groundbreaking discoveries happen when different perspectives
                come together.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-1284" data-mp="2penql2lh02iv">
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1285" data-mp="2pd2wfe32illj">
                <h3 className="text-xl font-bold text-navy-700 mb-3" data-id="element-1286" data-mp="2kh5ckxslix40">
                  Scientific Integrity
                </h3>
                <p className="text-gray-600" data-id="element-1287" data-mp="2fg7wcqr5cd55">
                  We uphold the highest standards of scientific rigor and
                  ethical research practices.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1288" data-mp="20weyoobv58sh">
                <h3 className="text-xl font-bold text-navy-700 mb-3" data-id="element-1289" data-mp="25ugg74tn501u">
                  Collaborative Spirit
                </h3>
                <p className="text-gray-600" data-id="element-1290" data-mp="1rvgsq0hv6r79">
                  We believe in the power of teamwork and cross-disciplinary
                  collaboration.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1291" data-mp="2kitc61sqaiwc">
                <h3 className="text-xl font-bold text-navy-700 mb-3" data-id="element-1292" data-mp="2okeqlrkwv58n">
                  Innovation Focused
                </h3>
                <p className="text-gray-600" data-id="element-1293" data-mp="2arp13d66bi6s">
                  We encourage creative thinking and novel approaches to complex
                  problems.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Benefits Section */}
        <section className="py-16 bg-gray-50" data-id="element-1294" data-mp="38846b0fkpf1i">
          <div className="container mx-auto px-4" data-id="element-1295" data-mp="389yt6kaenh88">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1296" data-mp="3hlw8bwwne6c6">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1297" data-mp="3dl2jn1bdsni8">
                Benefits & Perks
              </h2>
              <p className="text-gray-600" data-id="element-1298" data-mp="3rd0mwvievp6h">
                We offer competitive compensation and a comprehensive benefits
                package designed to support your professional growth and
                personal wellbeing.
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1299" data-mp="2ypmxdih1lvwe">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start bg-white p-6 rounded-lg shadow-sm" data-id="element-1300" data-mp="38miyh34m3fqx" data-mpi={index}>
                  <div className="mr-4 mt-1" data-id="element-1301" data-mp="33llimx72qxsl">{benefit.icon}</div>
                  <div data-id="element-1302" data-mp="nupigfxe991n">
                    <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-1303" data-mp="nu7e0w0kvoin">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1304" data-mp="2dcw76c78iyl0">{benefit.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Open Positions Section */}
        <section className="py-16" data-id="element-1305" data-mp="2md2ethg954c9">
          <div className="container mx-auto px-4" data-id="element-1306" data-mp="2mc15bhevwpwn">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1307" data-mp="2r410kwk0eumw">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1308" data-mp="2r6dpxus3k79z">
                Open Positions
              </h2>
              <p className="text-gray-600" data-id="element-1309" data-mp="312goyrrnjpsp">
                Join our team of dedicated scientists, researchers, and
                professionals working to advance microbiome science.
              </p>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-1310" data-mp="3a3omh7mcgmlq">
              {openPositions.map((position, index) => <div key={index} className="mb-6 border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-1311" data-mp="1aquc2zv2iio4" data-mpi={index}>
                  <div className="p-6" data-id="element-1312" data-mp="185we3lsi92je">
                    <div className="flex justify-between items-start mb-4" data-id="element-1313" data-mp="187pjkxrdtgpt">
                      <div data-id="element-1314" data-mp="13e4l74lvmkq3">
                        <h3 className="text-xl font-bold text-navy-700" data-id="element-1315" data-mp="13ctht5wcfezi">
                          {position.title}
                        </h3>
                        <p className="text-gray-600" data-id="element-1316" data-mp="thhzyepn1rnj">
                          {position.department} • {position.location} •{' '}
                          {position.type}
                        </p>
                      </div>
                      <a href={position.link} className="bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors duration-300" data-id="element-1317" data-mp="1m5xcmularxvp">
                        Apply
                      </a>
                    </div>
                    <p className="text-gray-700" data-id="element-1318" data-mp="5sp92wnvi9zs">{position.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Application Process */}
        <section className="py-16 bg-gray-50" data-id="element-1319" data-mp="3nxrqq8i2uhst">
          <div className="container mx-auto px-4" data-id="element-1320" data-mp="3jz237n3brjvg">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1321" data-mp="3jw66u374l394">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-1322" data-mp="1l1i7ovw5ita">
                Application Process
              </h2>
              <p className="text-gray-600" data-id="element-1323" data-mp="3swuiwscyktjd">
                Our hiring process is designed to be thorough yet efficient,
                allowing both you and our team to determine if there's a mutual
                fit.
              </p>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-1324" data-mp="kjdql8ezaont">
              <div className="relative" data-id="element-1325" data-mp="kh1al0ss6ode">
                {/* Process Steps */}
                <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-gray-200 transform -translate-x-1/2" data-id="element-1326" data-mp="fku5tbc4fix1"></div>
                <div className="space-y-12" data-id="element-1327" data-mp="2hbfd6k0xlj06">
                  {[{
                  title: 'Application Review',
                  description: 'Our team reviews your application materials to assess your qualifications and fit.'
                }, {
                  title: 'Initial Interview',
                  description: 'A conversation with our HR team to discuss your background, interests, and the role.'
                }, {
                  title: 'Technical Assessment',
                  description: 'Depending on the role, you may be asked to complete a skills assessment or case study.'
                }, {
                  title: 'Team Interviews',
                  description: 'Meet with potential teammates and leaders to discuss technical skills and cultural fit.'
                }, {
                  title: 'Final Decision',
                  description: 'We aim to provide timely feedback and, if selected, present you with an offer.'
                }].map((step, index) => <div key={index} className="relative flex items-start" data-id="element-1328" data-mp="33dk4pglb2gty" data-mpi={index}>
                      <div className="hidden md:block absolute left-1/2 top-0 w-6 h-6 bg-teal-500 rounded-full border-4 border-white transform -translate-x-1/2 z-10" data-id="element-1329" data-mp="33fwu2ete7th1"></div>
                      <div className="md:w-1/2 md:pr-8 md:text-right md:mr-4 md:ml-auto" data-id="element-1330" data-mp="3v4ghkh7d8lh8">
                        {index % 2 === 0 ? <>
                            <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-1331" data-mp="3mbwg78zow2sp">
                              {step.title}
                            </h3>
                            <p className="text-gray-600" data-id="element-1332" data-mp="inur16wc912u">{step.description}</p>
                          </> : null}
                      </div>
                      <div className="md:w-1/2 md:pl-8 md:ml-4" data-id="element-1333" data-mp="dvjorxe4l374">
                        {index % 2 === 1 ? <>
                            <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-1334" data-mp="q740t18rb1sf">
                              {step.title}
                            </h3>
                            <p className="text-gray-600" data-id="element-1335" data-mp="v55ipiug4v2b">{step.description}</p>
                          </> : null}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="py-16 bg-navy-800 text-white" data-id="element-1336" data-mp="1dwyd9hp5yoc5">
          <div className="container mx-auto px-4" data-id="element-1337" data-mp="1dxgiv4xpuewq">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1338" data-mp="1ivrqra4gafcb">
              <h2 className="text-3xl font-bold mb-6" data-id="element-1339" data-mp="1iv86vnv8pgvn">
                Ready to Make an Impact?
              </h2>
              <p className="text-xl mb-8" data-id="element-1340" data-mp="1mvs40rftckhs">
                We're looking for passionate individuals to join our mission of
                advancing microbiome science and improving human health.
              </p>
              <a href="/contact" className="inline-block bg-teal-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-teal-600 transition-colors duration-300" data-id="element-1341" data-mp="1a8dssjazgox0">
                Contact Our Recruiting Team
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1342" data-mp="vc671ejxfffm" />
    </div>;
}